import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import WebDevelopment from '@/pages/WebDevelopment';
import SocialMedia from '@/pages/SocialMedia';
import Maintenance from '@/pages/Maintenance';
import About from '@/pages/About';
import CaseStudies from '@/pages/CaseStudies';
import Booking from '@/pages/Booking';
import ClientTraining from '@/pages/ClientTraining';
import NotFound from '@/pages/NotFound';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/social-media" element={<SocialMedia />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/client-training" element={<ClientTraining />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;